module.exports = __webpack_public_path__ + "media/images/emoticons/eye-82d7ec372b9d7751ab5f148f6aeab945.gif";